import { PayError } from '@app/components/Stripe';
import { PaymentErrorCodes } from '@app/types/monolith/PaymentErrorCodes';
import { StripeError, StripeErrorType } from '@stripe/stripe-js';

export const NonLoggableStripeSDKErrors = new Set<StripeErrorType>([
  'validation_error',
]);

export const isLoggableStripeSDKError = (error: StripeError) =>
  !NonLoggableStripeSDKErrors.has(error.type);

export const NonLoggablePaymentErrors = new Set<PaymentErrorCodes>([
  PaymentErrorCodes.INVALID_ADDRESS,
  PaymentErrorCodes.INVALID_COUPON,
  PaymentErrorCodes.LICENSED_WORK_NOT_SALEABLE,
  PaymentErrorCodes.NO_PURCHASABLE_ITEMS,
  PaymentErrorCodes.SHIPPING_COUNTRY_BLOCKED,
  PaymentErrorCodes.VALIDATION_ERROR,
  PaymentErrorCodes.FRAUD_DECLINED,
]);

export const isLoggablePaymentError = (error: PayError) =>
  !NonLoggablePaymentErrors.has(error.code as PaymentErrorCodes);
